<template>
  <div class="product-items-slider-fi">
    <product-teasers-fi
      :custom-fields="customFields"
      :products
      :light="isLight"
      :white
      :expandable
      is-guided-recommandation
    />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';

import type { CatalogItem } from '@/pages/product-teasers-fi/ProductTeasersFi.vue';

defineOptions({ name: 'ProductItemsSliderFi' });

const ProductTeasersFi = defineAsyncComponent(
  () => import('@/pages/product-teasers-fi/ProductTeasersFi.vue'),
);

const props = withDefaults(
  defineProps<{
    productItems?: any[];
    /** already resolved catalog data; skips the teaser's own product lookup */
    products?: CatalogItem[];
    sliderHeadline?: string;
    isFamily?: boolean;
    isLight?: boolean;
    expandable?: boolean;
    white?: boolean;
  }>(),
  {
    productItems: () => [],
    products: undefined,
    sliderHeadline: '',
    isFamily: false,
    isLight: false,
  },
);

const productListValue = computed(() => ({
  value: props.productItems?.map(({ ProductId }: any) => ProductId).join('|'),
}));

const customFields = computed(() => {
  const fields: Record<string, any> = {
    headline: { value: props.sliderHeadline },
    hideContent: { value: true },
  };

  if (props.isFamily) {
    fields.familyList = productListValue.value;
  } else {
    fields.productList = productListValue.value;
  }

  return fields;
});
</script>

<style scoped src="./product-items-slider-fi" />
